export const validate = async (data, rules) => {
    const errors = []
    for (const field of Object.keys(rules)) {
        const rule = rules[field]
        const hasError = await rule(data[field])
        if (hasError) {
            errors.push(hasError)
        }
    }
    if (errors.length > 0) {
        throw new Error(errors.join(', '))
    }
}

export const minLength = (size, message) => {
    return async (value) => {
        if (value.length < size) {
            return message
        }
    }
}

export const notEmpty = (message) => {
    return async (value) => !!value ? message : null
}
